var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"close-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42.5 42.5"}},[_c('line',{staticClass:"cls-2",style:({
      stroke: _vm.circleCrossColor,
      strokeWidth: _vm.lineWidth,
      strokeLinecap: _vm.lineCap
    }),attrs:{"x1":_vm.lineOne.x1,"y1":_vm.lineOne.y1,"x2":_vm.lineOne.x2,"y2":_vm.lineOne.y2}}),_c('line',{staticClass:"cls-2",style:({
      stroke: _vm.circleCrossColor,
      strokeWidth: _vm.lineWidth,
      strokeLinecap: _vm.lineCap
    }),attrs:{"x1":_vm.lineTwo.x1,"y1":_vm.lineTwo.y1,"x2":_vm.lineTwo.x2,"y2":_vm.lineTwo.y2}})])
}
var staticRenderFns = []

export { render, staticRenderFns }